/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Form page for adding new bikes to the fleet. Provides input validation
and handles the creation of new bike entries in the system.
*/

import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import AddBikeForm from "./components/AddBikeForm";

const AddBikePage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="outline" size="sm" asChild>
          <Link to="/bikes">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to eBikes
          </Link>
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">Add New eBike</h1>
      </div>
      
      <div className="rounded-lg border p-6 shadow-sm">
        <AddBikeForm />
      </div>
    </div>
  );
};

export default AddBikePage;
